// extracted by mini-css-extract-plugin
export default {"container":"Xo-z","ratingLayout":"Yo-z","ratingLabel":"Zo-z","nonInteractiveRatingLabel":"_o-z"};